import PlaceholderIcon from "../Assets/Icons/no-image.jpg";

// Convert Array of Object into Dropdown like Format
export const convertDropdown = (data) => {
  return (
    data &&
    data?.map((i) => ({
      value: i.name,
      label: i.name,
      id: i.id,
    }))
  );
};

export const FilterById = (data, id) => {
  const result = data.filter((item) => parseInt(item.id) === parseInt(id));
  return result.length > 0 ? result[0].label : null;
};

export const Placeholder = PlaceholderIcon;

// export const filterById = (items, idToFilter) => {
//   const FoundName = items?.filter(
//     (item) => parseInt(item.id) === parseInt(idToFilter)
//   );
//   return FoundName ? FoundName.label : null;
// };

export const filterById = (items, idToFilter) => {
  const foundItem = items?.find(
    (item) =>
      parseInt(item.id) === parseInt(idToFilter) ||
      parseInt(item.value) === parseInt(idToFilter)
  );

  if (!foundItem) return null;

  return foundItem.label || foundItem.value || null;
};

export const filterByIdByFurcation = (items, idToFilter) => {
  // console.log("ITEMS: ", items);
  // console.log("ID TO FILTER: ", idToFilter);

  if (!items || !Array.isArray(items)) return null;

  for (const group of items) {
    const foundItem = group.options?.find(
      (item) => parseInt(item.value) === parseInt(idToFilter)
    );

    if (foundItem) {
      // console.log("FOUND ITEM: ", foundItem);
      return foundItem; // ✅ Return full object { label, value }
    }
  }

  return null;
};

// export const BASE_URL = process.env.REACT_APP_BASE_URI;

export const getEnvironment = (url) => {
  if (!url) return "unknown";
  if (url.includes("staging")) return "staging";
  if (url.includes("erp-testlive.sevenrocks.in")) return "test";
  return "erp";
};

export const convertDropdownObject = (obj) => {
  if (!obj) return [];
  return Object.entries(obj).map(([key, value]) => ({
    label: value?.toString() || key,
    value: key,
  }));
};

// ✅ Utility to remove empty filters
export const removeEmptyFilters = (filters) => {
  return Object.fromEntries(
    Object.entries(filters).filter(
      ([_, value]) => value !== "" && value !== null && value !== undefined
    )
  );
};
